package pl.finn.forms.fk02

import io.kvision.form.upload.UploadInput
import io.kvision.html.Button
import io.kvision.modal.Confirm
import io.kvision.redux.createReduxStore
import io.kvision.utils.getContent
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import pl.finn.forms.*


object Model : CoroutineScope by CoroutineScope(Dispatchers.Default + SupervisorJob())  {

    val formsService = FormsService()
    val fk02Service = Fk02Service()

    val formularzStore =
            createReduxStore(
                    ::formularzReducer,
                    Formularz(FormularzWidok.PUSTY)
            )

    fun nowy(token: String, app: App) {
        launchWithProgress {
            val formData = fk02Service.nowy(token)
            formularzStore.dispatch(FormularzAction.Nowy(formData))
            app.aktywujFk02()
            window.scrollTo(0.0, 0.0)
        }
    }

    fun sprawdz() {
        val state = Model.formularzStore.getState()
        launchWithProgress {
            val res = fk02Service.sprawdz(state.form!!, state.token!!)
            println(res)
        }
    }

    fun zapisz(form: Fk02Form, validateResult: String?) {
        if(validateResult == null){
            launchWithProgress {
                val state = formularzStore.getState()
                val url = fk02Service.zapisz(form, validateResult, state.token!!)
                window.location.href = url
            }
        } else {
            sprawdz()
        }
    }

    fun podglad(form: Fk02Form, button: Button) {
        launchWithProgress {
            val state = formularzStore.getState()
            val xml = fk02Service.podglad(form, state.token!!)
            PodgladWindow(state.token).pokazTresc(xml, button)
        }
    }

    fun edycja(token: String, app: App) {
        launchWithProgress {
            val formData = fk02Service.edycja(token)
            formularzStore.dispatch(FormularzAction.Edycja(formData))
            app.aktywujFk02()
            window.scrollTo(0.0, 0.0)
        }
    }

    fun anuluj() {
        launchWithProgress {
            val state = formularzStore.getState()
            val url = formsService.anuluj(state.token!!)
            window.location.href = url
        }
    }
}